import axios from 'axios'

const envBaseURL = (process.env.VUE_APP_API_BASE_URL || process.env.VITE_APP_BASE_API || '').trim()
const defaultBaseURL = process.env.NODE_ENV === 'development' ? 'http://localhost:6333/' : '/api'

const service = axios.create({
  baseURL: envBaseURL || defaultBaseURL,
  timeout: 10000
})

service.interceptors.request.use(
  config => {
    return config
  },
  error => {
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    const res = response.data
    return res
  },
  error => {
    console.error('响应错误:', error)
    return Promise.reject(error)
  }
)

export default service
